import { compact, split } from 'lodash';

export function splitWithNoFalsyValues(
  string: string,
  separator = '.',
): string[] {
  return compact(split(string, separator));
}
